<template>
    <b-card-footer
            class="house-info"
            :data-hideOnBalloon="hideOnBalloon"
    >
        <b-card-text class="house-info-text">
              <span class="house-info-elem">
                <span class="strong">
                    {{ propertyAppResource.bedrooms ? propertyAppResource.bedrooms : '-' }}
                </span>
                  {{ beds }}
              </span>
            <span class="house-info-elem">
                  <span class="strong">
                      {{ propertyAppResource.bathrooms ? propertyAppResource.bathrooms : '-' }}
                  </span>
                {{ baths }}
              </span>
            <span class="house-info-elem">
                  <span class="strong">
                      {{ propertyAppResource.size ? formatSize(propertyAppResource.size) : '-' }}
                  </span>
                {{ retrieveSizeUnit(propertyAppResource.sizeUnits) }}
              </span>
        </b-card-text>
    </b-card-footer>
</template>

<script>
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import {SIZE_UNIT_MAPING} from "../../../helpers/variables";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    export default {
        name: "PropertyListingCardFooter",
        props: {
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value){
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
            hideOnBalloon: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            beds() {
                return this.propertyAppResource.bedrooms > 1 ? 'beds' : 'bed';
            },
            baths() {
                return this.propertyAppResource.bathrooms > 1 ? 'baths' : 'bath';
            }
        },
        methods: {
            /**
             * Retrieve the size based on unit measurement
             *
             * @param val {number}
             * @returns {string}
             */
            retrieveSizeUnit(val) {
                return val ? SIZE_UNIT_MAPING[val] : '';
            },
            formatSize(value) {
                return (value || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
    };
</script>
